import React from "react";
import ReactDOM from "react-dom/client"; // Use ReactDOM/client
import App from "./App";
import { CartProvider } from "./context/CartContext"; // Ensure this path is correct

const root = ReactDOM.createRoot(document.getElementById("root")); // Use createRoot
root.render(
  <CartProvider>
    <App />
  </CartProvider>
);


